export default __webpack_public_path__ + "static/media/socialM-2.5aae48a2.png";